import { Injectable } from '@angular/core';
import {
  IEmailSmsQuotaV2,
  IEmailSmsSubscription,
} from '@g99-product-web-ui/shared-interface-lib';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';

import { HttpService } from '../../core/http-service/http.service';

@Injectable({
  providedIn: 'root',
})
export class SharedEmailSmsSubscriptionService {
  constructor(private readonly _httpService: HttpService) {}

  public getQuotaInfo() {
    const url = API_ENDPOINTS.EMAIL_SMS_QUOTA.quotaInfo;
    return this._httpService.get<IEmailSmsSubscription>(url);
  }

  public getQuotaInfoV2() {
    const url = API_ENDPOINTS.EMAIL_SMS_QUOTA.quotaV2;
    return this._httpService.get<IEmailSmsQuotaV2>(url);
  }
}
